module.exports = __webpack_public_path__ + "static/media/BJ.2d85741f.png";